import {
  COOKIE_DOMAIN,
  COOKIE_EXPIRES_IN_DAYS,
  COOKIE_PATH,
  COOKIE_SAMESITE,
  COOKIE_SECURE,
} from '../config';
import { shouldSaveKeyInCookie } from '../utils/should-save-key-in-cookie';

import { createClientCookieStorage } from './client-cookie-storage';
import { createClientLocalStorage } from './client-local-storage';

import type { KeyValueStorageInterface } from 'aws-amplify/utils';

export const createClientStorage = (): KeyValueStorageInterface => {
  const local = createClientLocalStorage();
  const cookie = createClientCookieStorage({
    domain: COOKIE_DOMAIN,
    expires: COOKIE_EXPIRES_IN_DAYS,
    path: COOKIE_PATH,
    sameSite: COOKIE_SAMESITE,
    secure: COOKIE_SECURE,
  });

  return {
    setItem: async (key: string, value: string) => {
      if (shouldSaveKeyInCookie(key)) {
        return cookie.setItem(key, value);
      }

      return local.setItem(key, value);
    },

    getItem: async (key: string) => {
      const [cookieValue, localValue] = await Promise.all([
        cookie.getItem(key),
        local.getItem(key),
      ]);

      return cookieValue ?? localValue;
    },

    removeItem: async (key: string) => {
      await Promise.all([cookie.removeItem(key), local.removeItem(key)]);
    },

    clear: async () => {
      await Promise.all([cookie.clear(), local.clear()]);
    },
  };
};
